import Seo from "@/components/Seo";
import Packages from "@/components/home/Packages";
import WhyUs from "@/components/home/WhyUs";
import Faq from "@/components/home/Faq";
import LeadSection from "@/components/home/LeadSection";

export default function PaketlerPage() {
  return (
    <>
      <Seo title="Paketler & Fiyatlar | Ankara Düğün Fotoğrafçısı"
        description="Ankara düğün fotoğraf ve video paketleri: fotoğraf, sinematik video, albüm ve drone seçenekleriyle 3 farklı paket. Size en uygun paketi seçin."
        path="/paketler" />
      <div className="pt-16">
        <Packages />
      </div>
      <WhyUs />
      <Faq />
      <LeadSection />
    </>
  );
}
